import favorite from "../../../assets/shapes_svg/feed/Hearts.svg";
import "./Glossary.css";

const GlossaryCard = () => {
  return (
    <div
      className="glossary-card pt-3 d-flex flex-column"
      style={{
        alignItems: "center",
        width: "200px",
      }}
    >
      <h4
        className="mx-auto"
        style={{
          width: "fit-content",
          textAlign: "center",
          color: "#F2F8F0",
          marginBottom: "32px",
          fontSize: "18px",
          fontWeight: "bold",
        }}
      >
        Saved Glossary
      </h4>
      <img src={favorite} alt="Glossary Icons" width={90} />
    </div>
  );
};

export default GlossaryCard;
